import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Button,
} from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import get from 'lodash/get'
import styled from 'styled-components'
import TrashHover from '../../../../static/images/trash-hover.svg'

class AddAttachmentForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const attachment_loading = get(this.props, 'attachment_loading')
    const attachment_name = get(this.props, 'attachment_name')
    const attachment_url = get(this.props, 'attachment_url')
    const toggle = get(this.props, 'toggle')
    const uploadFile = get(this.props, 'uploadFile')
    const handleInput = get(this.props, 'handleInput')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ () => toggle() }>
          <HeadText>Upload Files</HeadText>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <Row style={ { marginTop: 10 } }>
                      <ColButton>
                        <div style={ { display: 'flex', alignItems: 'center' } }>
                          <ButtonUpload>
                              Browse
                            <InputUpload id='fileUpload' type="file" onChange={ (e) => uploadFile(e) } />
                          </ButtonUpload>
                          <BeatLoader
                            sizeUnit={ "px" }
                            size={ 10 }
                            color={ '#D44B49' }
                            loading={ attachment_loading }
                          />
                          <FileName href={ attachment_url }>
                            { !attachment_loading && attachment_name }
                          </FileName>
                          { !attachment_loading && attachment_name &&
                          <Trash onClick={ () => {
                            document.getElementById('fileUpload').value = ''
                            get(this.props, 'removeFile')()
                          } }
                          /> }
                        </div>
                        <TextMB>(Max 5 MB)</TextMB>
                      </ColButton>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <TextLabel >Description</TextLabel>
                      <textarea name='attachment_description' className="form-control rounded-0" rows="3" onChange={ (e) => handleInput(e) } />
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddAttachmentForm

const FileName = styled.a`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  margin-left: 2%;
  width: 50%;
  word-break: break-word;
`
const ColButton = styled(Col)`
  padding: 0px !important;
`
const HeadText = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  color: #AD2624;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham' !important;
  font-size: 16px ;
  color: #929292;
`
const InputUpload = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
`
const ButtonUpload = styled(Button)`
  position: relative;
  overflow: hidden;
  font-family: 'Gotham';
  background-color:#FFFFFF;
  border: 1px solid #CCCCCC;
  color: #CCCCCC;
  width: 30%;
  height: 45px;
  cursor: pointer;
  margin-right: 5%;
  @media (max-width: 575.98px) {
    font-size: 12px;
    width: 40%;
  }
`
const TextMB = styled(Label)`
  font-family: 'Gotham';
  font-size: 12px ;
  color: #929292;
  margin: 0px;
`
const Trash = styled.div`
  background-image: url(${TrashHover});
  background-repeat: no-repeat;
  align-self: center;
  border: 0;
  width: 20px;
  height: 20px;
  margin: auto;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/upload-file/index.js